import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BilletLogService } from 'src/app/services/billet-log.service';

@Component({
  selector: 'app-billet-log',
  templateUrl: './billet-log.component.html',
  styleUrls: ['./billet-log.component.scss']
})
export class BilletLogComponent implements OnInit {
  billetId: number | null = null;
  logs: any[] = [];
  
  constructor(
    private billetLogService: BilletLogService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
  }

  search(): void {
    this.spinner.show();
    this.logs = [];
    
    if (this.billetId) {
      this.billetLogService.getBilletStatusLogs(this.billetId).subscribe({
        next: (response) => {
          this.logs = response;
          this.sortLogs();
          this.spinner.hide();
        },
        error: (error) => {
          console.error('Erro ao buscar logs do boleto:', error);
          this.spinner.hide();
        }
      });
    } else {
      this.billetLogService.getBilletStatusLogsByMarina().subscribe({
        next: (response) => {
          this.logs = response;
          this.sortLogs();
          this.spinner.hide();
        },
        error: (error) => {
          console.error('Erro ao buscar logs da marina:', error);
          this.spinner.hide();
        }
      });
    }
  }

  private sortLogs(): void {
    if (this.logs && this.logs.length > 0) {
      this.logs.sort((a, b) => {
        if (a.changeDate < b.changeDate) return 1;
        if (a.changeDate > b.changeDate) return -1;
        return 0;
      });
    }
  }
}
